import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import store from './store'

import ListingSearchPage from './components/ListingSearchPage'
import ContactPage from './components/ContactPage'
import SalesPage from './components/SalesPage'
import HomePage from './components/HomePage'
import FeaturedListingsManager from './components/FeaturedListingsManager'
import AgentPage from './components/AgentPage'
import FileNotFoundPage from './components/FileNotFoundPage'

/*
  Individual component imports for ElementUI didn't seem to affect the bundle
  size.  Is there something incorrect somewhere?
*/
import {
  Form, Tabs, TabPane, FormItem, Select, Option, InputNumber, Dialog,
  DatePicker, CheckboxGroup, CheckboxButton, OptionGroup, Switch, Input,
  Alert, Pagination, Dropdown, DropdownItem, DropdownMenu, Button, Notification
} from 'element-ui'

Vue.component(Form.name, Form)
Vue.component(Button.name, Button)
Vue.component(Tabs.name, Tabs)
Vue.component(TabPane.name, TabPane)
Vue.component(FormItem.name, FormItem)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)
Vue.component(InputNumber.name, InputNumber)
Vue.component(Dialog.name, Dialog)
Vue.component(DatePicker.name, DatePicker)
Vue.component(CheckboxGroup.name, CheckboxGroup)
Vue.component(CheckboxButton.name, CheckboxButton)
Vue.component(OptionGroup.name, OptionGroup)
Vue.component(Switch.name, Switch)
Vue.component(Input.name, Input)
Vue.component(Alert.name, Alert)
Vue.component(Pagination.name, Pagination)
Vue.component(Dropdown.name, Dropdown)
Vue.component(DropdownItem.name, DropdownItem)
Vue.component(DropdownMenu.name, DropdownMenu)
Vue.prototype.$notify = Notification;

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
locale.use(lang)

// import ElementUI from 'element-ui'
// import locale from 'element-ui/lib/locale/lang/en'
// Vue.use(ElementUI, { locale });

import 'element-ui/lib/theme-chalk/index.css';
import './element-variables.scss'

// import GAuth from 'vue-google-oauth2'
// const gauthOption = {
//   clientId: '448746096656-qhpqcsdvj1v3hui9jmkg7dgq75gspbgb.apps.googleusercontent.com',
//   scope: 'profile email'
// }
// Vue.use(GAuth, gauthOption)

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Vuex)

const routes = [
  {path: '/listings', component: ListingSearchPage},
  {path: '/agents', component: AgentPage},
  {path: '/contact', component: ContactPage},
  {path: '/sales', component: SalesPage},
  {path: '/home', component: HomePage},
  {path: '/', component: HomePage},
  {path: '/manage/featured', component: FeaturedListingsManager},
  {path: '/group/:group', component: ListingSearchPage},
  {path: '/listing/:listing', component: HomePage},
  {path: '*', component: FileNotFoundPage }
]
const router = new VueRouter({
  mode: process.env.VUE_APP_ROUTER_MODE || "hash",
  routes,
  //scrollBehavior(to, from, savedPosition) {
  //  return  { x: 0, y: 335 }
  //}
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')